import * as S from './styles';

export interface DividerProps {
  /** y axis margin */
  my?: number;
}

export default function Divider({ my = 16 }: DividerProps) {
  return <S.Wrapper my={my} />;
}
